import './BetbookCommentHeader.less';

import clsx from 'clsx';
import React from 'react';
import UserAvatar from '@/common/components/user-avatar/UserAvatar';

function BetbookCommentHeader({ avatarId, className, date, nickname, redactor, children }) {
    return (
        <div className={clsx('betbook-comment-header', className)}>
            <UserAvatar avatarId={avatarId} redactor={redactor} />
            <div className={clsx('nickname', { redactor })}>{nickname}</div>
            <div className="comment-date">{date}</div>
            {children}
        </div>
    );
}
export default BetbookCommentHeader;
